import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const MyBannerVideo = () => {
    useEffect(() => {
        AOS.init();
    }, []);

    const slides = [
        {
            img: "/assets/images/banner/1.jpg",
            caption:
                "McGAN'S Ooty School of Architecture.",
        },
        {
            img: "/assets/images/banner/2.jpg",
            caption:
                "Celebrating milestone achievements and bright futures ahead at McGAN'S Ooty School of Architecture",
        },
        {
            img: "/assets/images/banner/3.jpg",
            caption:
                "Ar. Jacob Cherian engaging with students during a design presentation, in the presence of our Chairman, Mr. N. Murali Kumaran",
        },
        {
            img: "/assets/images/banner/4.jpg?v=2",
            caption:
                "Mr. N. Murali Kumaran, Chairman of McGAN'S Ooty School of Architecture",
        },
        {
            img: "/assets/images/banner/5.jpg",
            caption:
                "Dr. P. Jayasudha, Principal of McGan's Ooty School of Architecture",
        },
        {
            img: "/assets/images/banner/8.jpg",
            caption:
                "Mrs. Gowri Vijayshankar, CEO of McGan's Ooty School of Architecture",
        },
        {
            img: "/assets/images/banner/6.jpg",
            caption:
                "Celebrating talent, passion and student spirit at McGAN'S",
        },
        {
            img: "/assets/images/banner/7.jpg",
            caption:
                "Students gathered for an attentive open-air session at our campus",
        },


    ];

    const [index, setIndex] = useState(0);

    useEffect(() => {
        const id = setInterval(() => {
            setIndex((i) => (i + 1) % slides.length);
        }, 4000);
        return () => clearInterval(id);
    }, [slides.length]);

    const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);
    const next = () => setIndex((i) => (i + 1) % slides.length);

    return (
        <>
            {/* Responsive styles injected directly */}
            <style>{`
                .mcg-banner-outer {
                    position: relative;
                    width: 100%;
                    max-width: 100%;
                    overflow: hidden;
                    background: #222;
                    margin-left: 0;
                    margin-right: 0;
                    padding: 0;
                    box-sizing: border-box;
                }
                .mcg-banner-img {
                    display: block;
                    width: 100%;
                    height: 600px;
                    min-height: 300px;
                    object-fit: cover;
                    object-position: center center;
                }
                /* Large desktop >= 1400px */
                @media (min-width: 1400px) {
                    .mcg-banner-img { height: 600px; }
                }
                /* Desktop 1200px-1399px */
                @media (max-width: 1399px) and (min-width: 1200px) {
                    .mcg-banner-img { height: 600px; }
                }
                /* Tablet landscape 992px-1199px */
                @media (max-width: 1199px) {
                    .mcg-banner-img { height: 60vh; }
                }
                /* Tablet portrait 768px-991px */
                @media (max-width: 991px) {
                    .mcg-banner-img { height: 55vh; }
                    .mcg-banner-caption { font-size: 0.95rem !important; }
                }
                /* Mobile landscape 576px-767px */
                @media (max-width: 767px) {
                    .mcg-banner-img { height: 45vh; min-height: 240px; }
                    .mcg-banner-caption { font-size: 0.88rem !important; top: 10px !important; }
                }
                /* Mobile portrait <= 575px */
                @media (max-width: 575px) {
                    .mcg-banner-img { height: 38vh; min-height: 200px; }
                    .mcg-banner-caption { font-size: 0.75rem !important; padding: 5px 10px !important; width: 92% !important; }
                    .mcg-nav-btn { padding: 6px 8px !important; font-size: 1.1rem !important; }
                }
            `}</style>

            <div className="mcg-banner-outer">

                {/* Slide image */}
                <img
                    className="mcg-banner-img"
                    src={slides[index].img}
                    alt={slides[index].caption}
                    width={2000}
                    height={765}
                />

                {/* Dark overlay */}
                <div
                    aria-hidden="true"
                    style={{
                        position: "absolute",
                        inset: 0,
                        background: "rgba(0,0,0,0.40)",
                        zIndex: 1,
                    }}
                />

                {/* Caption - top centre */}
                <div
                    className="mcg-banner-caption"
                    style={{
                        position: "absolute",
                        top: "20px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        color: "#fff",
                        fontSize: "1.15rem",
                        fontWeight: "600",
                        textAlign: "center",
                        width: "88%",
                        maxWidth: "900px",
                        zIndex: 3,
                        background: "rgba(0,0,0,0.42)",
                        padding: "8px 18px",
                        borderRadius: "8px",
                        lineHeight: "1.5",
                    }}
                    data-aos="fade-down"
                    data-aos-duration="800"
                >
                    {slides[index].caption}
                </div>

                {/* Prev button */}
                <button
                    className="mcg-nav-btn"
                    onClick={prev}
                    aria-label="Previous"
                    style={{
                        position: "absolute",
                        left: 16,
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "rgba(0,0,0,0.45)",
                        color: "#fff",
                        border: "none",
                        padding: "10px 14px",
                        fontSize: "1.5rem",
                        lineHeight: 1,
                        borderRadius: "4px",
                        cursor: "pointer",
                        zIndex: 3,
                    }}
                >
                    ‹
                </button>

                {/* Next button */}
                <button
                    className="mcg-nav-btn"
                    onClick={next}
                    aria-label="Next"
                    style={{
                        position: "absolute",
                        right: 16,
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "rgba(0,0,0,0.45)",
                        color: "#fff",
                        border: "none",
                        padding: "10px 14px",
                        fontSize: "1.5rem",
                        lineHeight: 1,
                        borderRadius: "4px",
                        cursor: "pointer",
                        zIndex: 3,
                    }}
                >
                    ›
                </button>

                {/* Dot indicators */}
                <div
                    style={{
                        position: "absolute",
                        bottom: 14,
                        left: "50%",
                        transform: "translateX(-50%)",
                        display: "flex",
                        gap: 8,
                        zIndex: 3,
                    }}
                >
                    {slides.map((_, i) => (
                        <button
                            key={i}
                            onClick={() => setIndex(i)}
                            aria-label={`Slide ${i + 1}`}
                            style={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                border: "none",
                                background: i === index ? "#fff" : "rgba(255,255,255,0.45)",
                                cursor: "pointer",
                                padding: 0,
                            }}
                        />
                    ))}
                </div>
            </div>
        </>
    );
};

export default MyBannerVideo;
